import { useApiQuery } from '../useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { timeEntryEndpoints } from '@/lib/api/endpoints';
import { timeEntryKeys } from '@/lib/queryKeys';
import type { TimeEntry } from '@/types/timeEntry';

export function useAppointmentTimeEntries(appointmentId: string) {
  return useApiQuery<TimeEntry[]>({
    queryKey: timeEntryKeys.appointment(appointmentId),
    queryFn: () =>
      apiGet<TimeEntry[]>(operationsClient, timeEntryEndpoints.appointmentList(appointmentId)),
    enabled: Boolean(appointmentId),
  });
}
